module.exports = __webpack_public_path__ + "static/shouldiuse-80ff2c7ca9d4fa1384bebf05e2b01780.png";